import React from "react";
import { SetupInputGroupItem } from "../../AMIModel/SetupComponents/SetupInputGroup";
import { getStimulusDataList } from "../../../../services/Andes_v2/simulation";
class StimulusInputGroup extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      applyAll: false
    }
  }

  inputChange = (eleName, value) => {
    const { signalName, stimulus } = this.props;
    const { applyAll } = this.state;

    let _stimulus = { ...stimulus };
    if (eleName === 'applyAll') {
      this.setState({ applyAll: value });
    } else {
      if (eleName === 'length') {
        const taps = [value, String(value - 1)];
        const seed = stimulus.seed > Math.pow(2, value) ? 80 : stimulus.seed;

        _stimulus = {
          ..._stimulus,
          taps,
          seed,
          length: value
        }
      } else {
        _stimulus[eleName] = value;
      }
    }

    this.props.updateStimulus(signalName, _stimulus, eleName === 'applyAll' ? value : applyAll);
  }

  render() {
    const { applyAll } = this.state;
    const { stimulus } = this.props;
    return (
      <SetupInputGroupItem
        dataList={getStimulusDataList(stimulus, applyAll)}
        onChange={this.inputChange}
      />
    )
  }
}

export default StimulusInputGroup;

